module.exports = __webpack_public_path__ + "static/media/lo5d.4a4985c2.png";